import {Component, input} from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-sidebar-menu-item',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './sidebar-menu-item.component.html',
  styleUrl: './sidebar-menu-item.component.scss',
  // encapsulation: ViewEncapsulation.None
})
export class SidebarMenuItemComponent {
  name = input.required();
  menuLink = input<string>();
}
